import { render, staticRenderFns } from "./SwiperTypeThree.vue?vue&type=template&id=70b59a02&scoped=true&"
import script from "./SwiperTypeThree.vue?vue&type=script&lang=js&"
export * from "./SwiperTypeThree.vue?vue&type=script&lang=js&"
import style0 from "./SwiperTypeThree.vue?vue&type=style&index=0&id=70b59a02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b59a02",
  null
  
)

export default component.exports